import React, { Component } from 'react';
import { Grid, Icon, Form, Button, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { getInquiryDetails, exportXLSX } from '../../utils/rest';
import ReactTable from 'react-table';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';

const initialState = {
    acoAccountId: "",
    acoInvoiceId: "",
    conLastName: "",
    conFirstName: "",
    conSsn: "",
    groupType: "consumer",
    openAccounts: false
}
class Inquiry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isNewAccountRestricted: this.props._menuIsRestricted(this.props.items.menuItems, 1, 9),
            searchItems: [],
            searchIndex: initialState,
            errorOpen: false,
            searchStateChanged: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "am_inquiry.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.props.clearSearchItems("inquirySearch");
            this.setState({
                searchItems: [],
                searchStateChanged: true
            })
        }

    }

    handleChange = (e) => {
        this.setState({
            searchStateChanged: true,
            searchIndex: {
                ...this.state.searchIndex,
                [e.target.name]: e.target.value
            }
        });
    }

    handleChangeOnlyNumber = (e) => {
        const onlynumber = /^[0-9\b]+$/;
        if (onlynumber.test(e.target.value)) {
            this.setState({
                searchStateChanged: true,
                searchIndex: {
                    ...this.state.searchIndex,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    checkEmpty = (searchIndex, except) => {
        let r = false;
        for (let search in searchIndex) {
            if (searchIndex[search].length > 0 && except.indexOf(search) === -1) {
                r = true;
                break;
            }
        }
        return r;
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            loading: true
        }, () => {
            if (this.checkEmpty(this.state.searchIndex, ["groupType"])) {
                if (this.state.searchStateChanged) {
                    getInquiryDetails(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                        if (response !== null && (response instanceof Array)) {
                            this.setState({
                                //searchItems: response,
                                loading: false,
                                searchStateChanged: false
                            });
                            this.props.addSearchItems('inquirySearch', response);
                        }
                    }).then(() => {
                        this.setState({
                            loading: false
                        })
                    })
                } else {
                    this.setState({
                        loading: false,
                        searchStateChanged: false
                    })
                }
            } else {
                this.setState({
                    errorOpen: true,
                    loading: false
                })
            }
        });


    }

    close = () => {
        this.setState((prevState, props) => {
            return { errorOpen: false };
        });
    }

    render() {
        return (
            <div>
                {(this.state.loading) ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "Inquiry", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Input label={this.props.t("client.account") + ":"} placeholder={this.props.t("client.account")} width={3} name="acoInvoiceId" value={this.state.searchIndex.acoInvoiceId} onChange={this.handleChange} />
                                    <Form.Input label={this.props.t("our.account") + ":"} placeholder={this.props.t("our.account")} width={3} name="acoAccountId" value={this.state.searchIndex.acoAccountId} onChange={this.handleChangeOnlyNumber} />
                                    <Form.Input label="Consumer's Last Name:" placeholder='Lastname' width={3} name="conLastName" value={this.state.searchIndex.conLastName} onChange={this.handleChange} />
                                    <Form.Input label="Consumer's First Name:" placeholder='Firstname' width={3} name="conFirstName" value={this.state.searchIndex.conFirstName} onChange={this.handleChange} />
                                    <Form.Input label='SSN:' width={2} name="conSsn" value={this.props._ifNull(this.state.searchIndex.conSsn, "")} onChange={this.handleChange} placeholder='000000000' type="text" maxLength="9" />
                                    <Form.Field width={2} >
                                        <Button.Group className="small push-down">
                                            <Button onClick={() => this.setState((prevState, props) => {
                                                return {
                                                    searchIndex: initialState
                                                };
                                            })}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <h4 className="ui header">
                                        <Icon name="search" />
                                        <div className="content">
                                            Inquiry
                                            </div>
                                        <div className="right floated content push-up small-font">
                                        </div>
                                    </h4>
                                </Segment>
                                <Grid className="margin-bottom-5">
                                    <Grid.Column width={1} floated='right' className="remvespace-btm">
                                        <Button onClick={() => {
                                            exportXLSX(
                                                {
                                                    "Client Name": "cltName",
                                                    "Our Client Identifier": "cltClientId",
                                                    "Consumer's Last Name": "conLastName",
                                                    "Consumer's First Name": "conFirstName",
                                                    "Consumer Address": "coaAddress1",
                                                    "City": "coaCity",
                                                    "SSN": "conSsn"
                                                }, this.props.search.inquirySearch, "Inquiry.xlsx")
                                        }}
                                            className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.props.search.inquirySearch.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                                    data={this.props.search.inquirySearch}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}
                                    columns={[
                                        {
                                            Header: "#",
                                            maxWidth: 50,
                                            filterable: false,
                                            Cell: (row) => {
                                                return <div>{row.index + 1}</div>;
                                            }
                                        },

                                        {
                                            Header: props => <span data-inverted="" data-tooltip="Client Name" data-position="bottom left">Client Name</span>,
                                            accessor: 'cltName'
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                            accessor: 'cltClientId',
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Consumer's Last Name" data-position="bottom left">{this.props.t("lastname")}</span>,
                                            accessor: 'conLastName',
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Consumer's First Name" data-position="bottom left">{this.props.t("firstname")}</span>,
                                            accessor: 'conFirstName',
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Consumer's Street Address" data-position="bottom left">{this.props.t("street.add")}</span>,
                                            accessor: 'coaAddress1',
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Consumer's City" data-position="bottom left">{this.props.t("city")}</span>,
                                            accessor: 'coaCity',
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Consumer's Social Security Number" data-position="bottom left">{this.props.t("ssn")}</span>,
                                            id: 'conSsn',
                                            accessor: row => (
                                                this.props._padString(row.conSsn, 4)
                                            )
                                        }, {
                                            Header: props => <span data-inverted="" data-tooltip="Clickable Action Buttons" data-position="bottom right">{this.props.t("actions")}</span>,
                                            filterable: false,
                                            style: {
                                                textAlign: "center"
                                            },
                                            Cell: row => (
                                                <div>
                                                    <Button as={Link} to={"/view/consumer/" + row.original.conConsumerId} className="icon mini" data-inverted="" data-tooltip="View Account Details" data-position="top right" ><Icon name="eye" /></Button>
                                                    <Button as={Link} to={"/view/account/" + row.original.conConsumerId} disabled={this.state.isNewAccountRestricted || this.props._clientRestriction(this.props.items.clients, row.original.cltClientId, "allowedtocreateaccount")} className="icon mini" data-inverted="" data-tooltip="Add Account for this Consumer" data-position="top right">+ Account</Button>
                                                </div>
                                            )
                                        }]}
                                />
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={9} open={this.state.errorOpen} close={this.close} />
            </div>
        );
    }
}
export default Inquiry;


// WEBPACK FOOTER //
// ./src/app/ui/accounts/Inquiry.js